import React, {useState, useEffect, useRef, useCallback} from 'react';
const TVA = require("../theta/tva.cjs.js").TVA;

function useTVA(tvaRef, videoId, classNames) {
    const videoNode = useRef(null);
    const [errorMessage, setErrorMessage] = useState('');
    const [isAccessBlocked, setIsAccessBlocked] = useState(true);

    const onError = (msg) => {
        console.error(msg);
        setErrorMessage(msg);
    };

    const onAccessOK = () => {
        setIsAccessBlocked(false);
    };

    const onAccessDenied = (err) => {
        setIsAccessBlocked(true);
        if (err) {
            onError(err);
        }
    };

    useEffect(() => {
        // Initialize TVA.Video instance
        tvaRef.current = new TVA.Video({
            videoId: videoId,
            videoEl: videoNode.current,
            onAccessOK,
            onAccessDenied,
            onError
        });

        // Cleanup function
        return () => {
            // Cleanup logic if necessary, for example:
            // if (tvaRef.current) {
            //   tvaRef.current.destroy(); // Assuming 'destroy' is a method to clean up TVA.Video instance
            // }
        };
    }, [videoId]);

    const Video = useCallback(
        ({children, ...props}) => (
            <div data-vjs-player key={videoId}>
                <video ref={videoNode} className={`video-js ${classNames}`} {...props}>
                    {children}
                </video>
            </div>
        ),
        [videoId]
    );

    return { Video, tva: tvaRef.current, errorMessage, isAccessBlocked };
}

export default useTVA;